export default __webpack_public_path__ + "static/media/icn_albedo.17c071b2.svg";